import { DefaultModel } from './default-model';
import { ModelWithStatisticByEarningRate } from './model-with-statistic';
import { OfferGeoModel } from './offer-geo-model';
import { OfferUrlModel } from './offer-url-model';
import { PartnerModel } from './partner-model';
import { UserModel } from './user.interface';

export enum OfferField {
  Name = 'name',
  Url = 'url',
  Urls = 'urls',
  CntLimit = 'cntLimit',
  DayCntLimit = 'dayCntLimit',
  SumLimit = 'sumLimit',
  DaySumLimit = 'daySumLimit',
  UnicCnt = 'unicCnt',
  Timeout = 'timeout',
  ProposalProbability = 'proposalProbability',
  PostbackUrl = 'postbackUrl',
  User = 'user',
  OfferGeos = 'offerGeos',
  Partner = 'partner',
  BuyFrom = 'buyFrom',
  TrafficSource = 'trafficSource',
  // blocking
  IsBlocked = 'isBlocked',
  BlockedBy = 'blockedBy',
  Subid = 'subid',
  AndroidVersion = 'androidVersion',
  DeviceVendor = 'deviceVendor', // text
  DeviceModel = 'deviceModel', // text
  PriceRange = 'priceRange', // varchar(255)
  PriceType = 'priceType', // Enum: cheap, medium, expensive

  Browser = 'browser',
  Messenger = 'messenger',
  Apps = 'apps',
  Language = 'language',

  Categories = 'mainCategories',
  TargetGender = 'targetGender',
  TargetAge = 'targetAge',
  SubCategories = 'categories',
}

export interface OfferShortModel extends DefaultModel {
  name: string;

  ecpm: number;
  statCnt: number;
  statSum: number;
  statUniqCnt: number;
}

export interface OfferFormBaseModel extends OfferShortModel {
  url: string;
  urls: OfferUrlModel[];
  cntLimit: number;
  dayCntLimit: number;
  sumLimit: number;
  daySumLimit: number;
  unicCnt: number;
  postbackUrl: string;
  subid: string;
  androidVersion: string;
  isActive: boolean;
  offerGeos?: Partial<OfferGeoModel>[];

  [OfferField.TargetGender]: string;
  [OfferField.TargetAge]: string;
  [OfferField.ProposalProbability]: number;
}

export interface OfferFormModel extends OfferFormBaseModel {
  [OfferField.Partner]?: string;
  [OfferField.BuyFrom]?: string[];

  [OfferField.DeviceVendor]: string;
  [OfferField.DeviceModel]: string;
  [OfferField.PriceType]: string;
  [OfferField.PriceRange]?: string;

  [OfferField.Browser]: string;
  [OfferField.Categories]: string;
  [OfferField.SubCategories]: string[];
  [OfferField.Apps]: string[];
}

export interface OfferModel<T = OfferGeoModel>
  extends OfferFormBaseModel,
    DefaultModel {
  user: UserModel;
  offerGeos: T[];
  is_auto_bid: boolean;
  [OfferField.Partner]: PartnerModel;
  [OfferField.IsBlocked]?: boolean;
  [OfferField.BlockedBy]?: UserModel;
}

export type OfferStatisticModel = ModelWithStatisticByEarningRate<OfferModel>;
